const INITIALIZED = 'INITIALIZED';
const FETCH = 'FETCH';
const FETCH_SUCCESS = 'FETCH_SUCCESS';
const FETCH_FAIL = 'FETCH_FAIL';
const RESET = 'RESET';

enum STATUS {
  IDLE,
  LOADING,
  SUCCESS,
  FAIL,
}

export { INITIALIZED, FETCH, FETCH_SUCCESS, FETCH_FAIL, RESET, STATUS };
